export const IDB_NAME = "GolfCoursePWA";
export const IDB_VERSION = 6;
